export class FeedBackDataModel {
    QId: string;
    Description: string;
    AnswerType: string;
    Control: string;
    Answer: string;
    WeightAge: string;
    AnsId: string;  

    FeedText: string;
    selectedWeightAge: string;

    PatientId: string;
    Isvalid: string;

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/feedback/feedbackdatamodel.ts